import React from 'react';
import styled from '@emotion/styled';
import PageHeader from '../components/PageHeader';

const PrivacyContainer = styled.div`
  padding: 2rem;
  max-width: 1000px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const ContentSection = styled.div`
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  padding: 2rem;
  border-radius: 15px;
  border: 2px solid rgba(255, 51, 51, 0.3);
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    padding: 1.5rem;
  }
  
  h2 {
    color: #ff3333;
    margin-top: 2rem;
    margin-bottom: 1rem;
    font-size: 1.8rem;
    
    &:first-of-type {
      margin-top: 0;
    }
  }
  
  p {
    line-height: 1.7;
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }

  ul, ol {
    margin-bottom: 1.5rem;
    padding-left: 1.5rem;
    
    li {
      margin-bottom: 0.5rem;
      line-height: 1.6;
    }
  }
`;



const PrivacyPolicy = () => {
  return (
    <>
      <PageHeader title="Privacy Policy" highlightWord="Policy" />
      <PrivacyContainer>
        <ContentSection>
          <p>At <span>Red<span style={{ color: '#ff3333' }}>Cloud</span> Storage</span>, your privacy is a priority. Our platform is built on the secure and open-source Nextcloud infrastructure, and we inherit its principles of data protection, transparency, and control.</p>
          <p>This Privacy Policy explains how we handle your personal information when you use our website and services hosted on <a style={{ color: '#ff3333', textDecoration: 'none' }} href="https://redcloudstorage.net">https://redcloudstorage.net</a>.</p>
          
          <h2>1. Who We Are</h2>
          <p><span>Red<span style={{ color: '#ff3333' }}>Cloud</span> Storage</span> offers cloud storage and collaboration tools built on Nextcloud. We are committed to safeguarding your personal data in compliance with data protection laws, including the General Data Protection Regulation (GDPR).</p>
          
          <h2>2. Information We Collect</h2>
          <p><strong>a. Data You Provide:</strong></p>
          <ul>
            <li>Name, email, and login credentials when creating an account</li>
            <li>Payment details (via our third-party processor)</li>
            <li>Support queries and feedback</li>
          </ul>
          <p><strong>b. Data Collected Automatically:</strong></p>
          <ul>
            <li>IP address, browser details, and session metadata</li>
            <li>Usage logs (for security and diagnostics)</li>
            <li>Cookies for session management and security</li>
          </ul>
          
          <h2>3. How We Use Your Data</h2>
          <p>We process your information to:</p>
          <ul>
            <li>Provide secure file storage and collaboration tools</li>
            <li>Maintain account functionality and system security</li>
            <li>Respond to your inquiries and support needs</li>
            <li>Comply with legal requirements</li>
          </ul>
          <p>We do not use your data for advertising or profiling.</p>
          
          <h2>4. Legal Basis for Processing</h2>
          <p>Our data processing is based on:</p>
          <ul>
            <li>Your consent (e.g., for cookies)</li>
            <li>Our contractual obligations to deliver the services</li>
            <li>Legal compliance</li>
            <li>Legitimate interests, such as service improvement and security</li>
          </ul>
          
          <h2>5. Data Sharing</h2>
          <p>Your personal data is not sold or rented. It may be shared with:</p>
          <ul>
            <li>Our hosting provider (under strict data processing agreements)</li>
            <li>Payment processors</li>
            <li>Legal authorities when required</li>
          </ul>
          <p>All third-party providers are GDPR-compliant.</p>
          
          <h2>6. Data Storage and Security</h2>
          <p>We use encrypted storage, secure authentication, and limited access controls to protect your information. Your files remain within your control and are never shared without your explicit action.</p>
          <p>Data is hosted in the US.</p>
          
          <h2>7. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Correct or delete your data</li>
            <li>Withdraw consent at any time</li>
            <li>File a complaint with a data protection authority</li>
          </ul>
          <p>To exercise these rights, email: <a style={{ color: '#ff3333', textDecoration: 'none' }} href="mailto:privacy-policy@redcloudstorage.net">privacy-policy@redcloudstorage.net</a></p>
          
          <h2>8. Cookies</h2>
          <p>We use cookies only for essential session and security purposes. You can control cookie settings through your browser.</p>
          
          <h2>9. Changes to This Policy</h2>
          <p>We may update this policy from time to time. Changes will be posted on this page with a revised effective date.</p>
          
          <h2>10. Contact</h2>
          <p><span>Red<span style={{ color: '#ff3333' }}>Cloud</span> Storage</span><br />
          Email: <a style={{ color: '#ff3333', textDecoration: 'none' }} href="mailto:support@redcloudstorage.net">support@redcloudstorage.net</a><br />
          Website: <a style={{ color: '#ff3333', textDecoration: 'none' }} href="https://redcloudstorage.net">https://redcloudstorage.net</a></p>
        </ContentSection>
      </PrivacyContainer>
    </>
  );
};

export default PrivacyPolicy;
